import { ContractStatusesSchema } from '@weft/types';
import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { PAGINATION_QUERY_PARAMETERS, SEARCH_QUERY_PARAMETER } from '../../../api-definition-params';
import { GET_CONTRACTS_OVERVIEWS_PATH } from './get-contracts-overviews-path';
import { GetContractsOverviewsResponseSchema } from './get-contracts-overviews-response-schema';

const CONTRACT_STATUSES_QUERY_PARAMETER = {
  name: 'contractStatuses',
  location: 'query',
  schema: ContractStatusesSchema,
} as const satisfies ZapiParam;

export const GET_CONTRACTS_OVERVIEWS_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-contracts-overviews',
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [CONTRACT_STATUSES_QUERY_PARAMETER.name]: CONTRACT_STATUSES_QUERY_PARAMETER,
  },
  response: {
    name: 'GetContractsOverviewsResponse',
    schema: GetContractsOverviewsResponseSchema,
  },
  path: GET_CONTRACTS_OVERVIEWS_PATH,
} satisfies ZapiAction;

export type GetContractsOverviewsAction = typeof GET_CONTRACTS_OVERVIEWS_ACTION;